module.exports = __webpack_public_path__ + "static/about_services02-cdd6d36a34821d61749fb89ef248bc10.png";